import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IAccountMovementQuotation } from "src/models/Accounting/Accounting.models";
import { ISale } from "src/models/Stores/Sale.models";

interface CustomerXSaleState {
    customerXSales: ISale[];
    customerXSalesERP: IAccountMovementQuotation[];
    customerXSaleToEdit: ISale | null;
}

const initialState: CustomerXSaleState = {
    customerXSales: [],
    customerXSalesERP: [],
    customerXSaleToEdit: null,
};

const customerXSaleSlice = createSlice({
    name: "CustomerXSale",
    initialState,
    reducers: {
      setCustomerXSaleList: (
        state,
        action: PayloadAction<ISale[]>
      ) => {
        state.customerXSales = action.payload;
      },
      setCustomerXSaleERPList: (
        state,
        action: PayloadAction<IAccountMovementQuotation[]>
      ) => {
        state.customerXSalesERP = action.payload;
      },
      concatListCustomerXSale: (
        state: CustomerXSaleState,
        action: PayloadAction<ISale[]>
      ) => {
        state.customerXSales = [
          ...state.customerXSales.concat(action.payload),
        ];
      },
      setCustomerXSaleToEdit: (
        state,
        action: PayloadAction<ISale | null>
      ) => {
        state.customerXSaleToEdit = action.payload;
      },
      addCustomerXSale: (
        state,
        action: PayloadAction<ISale>
      ) => {
        state.customerXSales.push(action.payload);
      },
      updateCustomerXSale: (
        state,
        action: PayloadAction<ISale>
      ) => {
        let itemIndex = state.customerXSales.findIndex(
          item =>
            // action.payload.isInList
            // ? item.memberClubId === action.payload.memberClubId
            /*:*/ item.saleId ===
            action.payload.saleId
        );
        if (itemIndex !== -1)
          state.customerXSales[itemIndex] = action.payload;
      },
      deleteCustomerXSale: (
        state,
        action: PayloadAction<ISale>
      ) => {
        const newArray = state.customerXSales.filter(item => item.saleId !== action.payload.saleId);
        state.customerXSales = newArray;
      },
    },
});

export const {
    setCustomerXSaleList,
    setCustomerXSaleERPList,
    concatListCustomerXSale,
    setCustomerXSaleToEdit,
    addCustomerXSale,
    updateCustomerXSale,
    deleteCustomerXSale,
} = customerXSaleSlice.actions;
  
export default customerXSaleSlice.reducer;